// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2c-8H","productName":"Table_productName__1-1kZ"};